import { z } from 'zod';
import { CARRIER_CONSTRAINTS } from './constraints.js';
export const serviceNameSchema = z
    .string()
    .trim()
    .min(1, `${CARRIER_CONSTRAINTS.serviceName.label} is required.`)
    .max(CARRIER_CONSTRAINTS.serviceName.maxLength);
//# sourceMappingURL=service-name-schema.js.map